import {Tags as TagsComponent} from '../../sidebar-shared/Tags'
import type {AppListing} from '@github-ui/marketplace-common'

type TagsProps = {
  app: AppListing
}

export function Tags({app}: TagsProps) {
  const tags = []

  if (app.primaryCategory) {
    const tagText = app.primaryCategory.toLowerCase().replace(' ', '-')
    tags.push({
      name: tagText,
      slug: tagText,
    })
  }

  if (app.secondaryCategory) {
    const tagText = app.secondaryCategory.toLowerCase().replace(' ', '-')
    tags.push({
      name: tagText,
      slug: tagText,
    })
  }

  return <TagsComponent type="apps" tags={tags} />
}

try{ Tags.displayName ||= 'Tags' } catch {}